import { render, staticRenderFns } from "./A7PainelAvaliacao.vue?vue&type=template&id=20efb75b&scoped=true&"
import script from "./A7PainelAvaliacao.vue?vue&type=script&lang=js&"
export * from "./A7PainelAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efb75b",
  null
  
)

export default component.exports